<template>
  <Navigation />
  <div class="uk-section">
    <div class="uk-container">
      <h1>Perfil</h1>
      <p>Puedes actualizar tu nombre.</p>
      <form @submit.prevent="updateUser">
        <div class="uk-margin">
          <label for="name">Name</label>
          <input type="text" class="uk-input" id="name" v-model="name" />
        </div>
        <div class="uk-margin">
          <label for="email">Email</label>
          <input type="email" class="uk-input" id="email" v-model="email" disabled/>
        </div>
        <button type="submit" class="uk-button uk-button-primary">
          Update
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation.vue";
import { getAuth, updateProfile } from "firebase/auth";

export default {
  name: "Reportes",
  components: {
    Navigation,
  },
  data() {
    return {
      user: {},
      name: "",
      email: "",
    };
  },
  methods: {
    updateUser() {
      updateProfile(getAuth().currentUser, {
        displayName: this.name,
      }).then(() => {
        alert("Profile updated");
      });
    },
  },
  created() {
    getAuth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
        this.name = user.displayName;
        this.email = user.email;
      }
    });
  },
};
</script>
